import type { HTMLAttributes } from 'react'

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** bg-elevated instead of bg-card — for menus, modals and toasts sitting above the base surface. */
  elevated?: boolean
}

export function Card({ elevated = false, className = '', ...rest }: CardProps) {
  return (
    <div
      className={[elevated ? 'bg-elevated' : 'bg-card', 'border border-subtle rounded-[10px]', className]
        .filter(Boolean)
        .join(' ')}
      {...rest}
    />
  )
}
